var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterMailNotificationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5028 9.1663V13.3347C17.5028 14.716 16.3831 15.8357 15.0018 15.8357H4.99762C3.61634 15.8357 2.49658 14.716 2.49658 13.3347V6.66526C2.49658 5.28397 3.61634 4.16422 4.99762 4.16422H12.5007",
    stroke: "#E80A0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7372 3.33054C16.1164 3.32909 15.5421 3.65939 15.2313 4.19671C14.9204 4.73404 14.9203 5.3965 15.231 5.93393C15.5417 6.47136 16.1158 6.80185 16.7366 6.8006H16.7372C17.3579 6.80206 17.9322 6.47176 18.243 5.93443C18.5539 5.39711 18.554 4.73464 18.2433 4.19721C17.9326 3.65978 17.3585 3.32929 16.7377 3.33054H16.7372Z",
    stroke: "#E80A0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 8.14831L11.2676 10.4073C10.447 11.0465 9.29291 11.0312 8.48951 10.3705L4.99756 7.49893",
    stroke: "#E80A0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterMailNotificationRed);
export default __webpack_public_path__ + "static/media/letter-mail-notification-red.f6c2daa7a438ac9a47a8a58b4dd85de4.svg";
export { ForwardRef as ReactComponent };